import { useFilters } from '@navent-jobs/ui-kit/hooks/filters'
import React, { useState } from 'react'
import { DataLayers } from '../../../../../components/filter/gtm-events-filters'
import { FilterScreen } from '../../../../../components/filter/filter-screen'
import { pushFilterToRecentSearches } from '../utils/pushfilter'
import { SITE_ID } from '../../../../../constants'
import features from '../../../../../constants/features-per-country'

const searchAvisosV2Enabled = features[SITE_ID || 'BMAR'].searchAvisosV2.enabled

export const FiltersMobile = ({
  urlService,
  routerMatch,
  allFilters,
  allAppliedFilters,
  filterSettings,
  deleteAll,
  defaultFilters,
}) => {
  const { filters, filtersApplied, performFiltering } = useFilters({
    allFilters,
    allAppliedFilters,
    urlService,
    routerMatch,
    filterSettings,
    defaultFilters,
    searchAvisosV2Enabled,
  })
  const [filterSelected, setFilterSelected] = useState()

  const selectFilter = filter => {
    if (filter.type === filterSelected?.type) {
      setFilterSelected(undefined)
    } else {
      setFilterSelected(filter)
    }
  }

  const metric = (filter, label) => {
    DataLayers.filterApplied(true, filter.label, label)
  }

  const onSearch = (type, facet) => {
    performFiltering(type, facet)
    pushFilterToRecentSearches([{ type, facetSelected: facet }], allAppliedFilters)
  }

  const onRemoveAll = () => {
    setFilterSelected(undefined)
    performFiltering('all', null)
  }

  return (
    <FilterScreen
      filters={filters}
      filtersApplied={filtersApplied}
      performFiltering={performFiltering}
      selectFilter={selectFilter}
      filterSelected={filterSelected}
      metric={metric}
      onSearch={onSearch}
      onRemoveAll={onRemoveAll}
      deleteAll={deleteAll}
    />
  )
}
